import React from "react";
import "./formInput.scss";
import { useField } from "formik";

const FormInput = ({ label, textarea, textareaValue, ...props }) => {
  const [field, meta] = useField(props);
  const hasError = meta.touched && meta.error;
  return (
    <div className="signup__input">
      <label>{label}</label>
      {!textarea ? (
        <input className={hasError ? "error" : ""} {...field} {...props} />
      ) : (
        <textarea
          className={hasError ? "error" : ""}
          {...field}
          {...props}
        ></textarea>
      )}

      {hasError && <p>{meta.error}</p>}
    </div>
  );
};

export default FormInput;
